import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import { FormattedMessage } from 'react-intl';
import { ButtonWrapper } from 'cstar-react-primitives';

import originRedirect from '../../utils/originRedirect';

import { cashbotName } from '../core/coreUtils';
import { orderConfirmationMessages } from './confirmationMessages';


export const NextSteps = ({ confirmationEmail }) => (
    <div className='next-steps'>
        <h2 className='next-steps__heading'>
            <FormattedMessage {...orderConfirmationMessages.nextSteps} />
        </h2>
        <div className="next-steps__item">
            <FormattedMessage {...orderConfirmationMessages.nextStepsConfirmationEmail} values={{email: confirmationEmail}} />
        </div>
        <ButtonWrapper
            type="button"
            onClick={originRedirect}
            cashbotName={cashbotName}
            cssClass={classNames('btn', 'btn--primary', 'no-print', 'next-steps__button')}
        >
            <FormattedMessage {...orderConfirmationMessages.continueShopping} />
        </ButtonWrapper>
    </div>
);

NextSteps.defaultProps = {
    confirmationEmail: undefined
};

NextSteps.propTypes = {
    confirmationEmail: PropTypes.string,
};
